<ng-container *ngIf="isServer || !isBrowser">
  <fitscovery-ui-default-skeleton-loader></fitscovery-ui-default-skeleton-loader>
</ng-container>

<ng-container *ngIf="isBrowser">
  <section class="partner-homepage" [ngSwitch]="(partnerSubject$ | async)?.appConfig?.homePageVer">
    <ng-container *ngSwitchCase="1">
      <fitscovery-feature-default-template [partner]="(partnerSubject$ | async)!" [imageDescriptions]="((partnerSubject$ | async)?.imageDescriptions)! | homepageSections"></fitscovery-feature-default-template>
    </ng-container>
    <ng-container *ngSwitchCase="3">
      <fitscovery-feature-groove-template [partner]="(partnerSubject$ | async)!" [imageDescriptions]="((partnerSubject$ | async)?.imageDescriptions)!| homepageSections"></fitscovery-feature-groove-template>
    </ng-container>
    <ng-container *ngSwitchCase="4">
      <fitscovery-feature-groove-template [partner]="(partnerSubject$ | async)!" [imageDescriptions]="((partnerSubject$ | async)?.imageDescriptions)! | homepageSections"></fitscovery-feature-groove-template>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <fitscovery-feature-default-template [partner]="(partnerSubject$ | async)!" [imageDescriptions]="((partnerSubject$ | async)?.imageDescriptions)! | homepageSections"></fitscovery-feature-default-template>
    </ng-container>
  </section>
</ng-container>
